import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "../store";
import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query";

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_Everest_API_URL,
  // Bearer token is supplied by the DMS desktop host over the WebView2 message bridge on
  // /sale-tax and /address-validation (see everestAuthSlice); memory-only, no fallback.
  prepareHeaders: (headers, { getState }) => {
    const state = getState() as RootState;
    const { code } = state.everestAuth;

    if (code) {
      headers.set("Authorization", `Bearer ${code}`);
    }
    return headers;
  },
});

const baseQueryWithCustomAuth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  return result;
};

export const everestApi = createApi({
  reducerPath: "everestApi",
  baseQuery: baseQueryWithCustomAuth,
  tagTypes: ["SalesTax"],
  endpoints: () => ({}),
});
